<template>
  <div id="app" style="height:100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
html,body{height: 100%;font-family: "PingFang SC", "Helvetica Neue", "Microsoft YaHei", sans-serif;}
</style>
